import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { router } from '@/app/router';

export function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster
          position="bottom-right"
          theme="light"
          closeButton
          toastOptions={{
            className:
              '!border !border-line !bg-board !text-ink !shadow-float !rounded-xl !font-sans',
          }}
        />
      </AuthProvider>
    </QueryProvider>
  );
}
